import { createStore, applyMiddleware, compose, GenericStoreEnhancer, combineReducers } from 'redux';
import * as _ from 'lodash';
import { IAppState } from './IAppState';
import freezeState from './freezeState';
import reducer from '../reducers';
import { loadState, saveState } from './local-storage';

declare var window: any;

const devToolsExtension: GenericStoreEnhancer = (window.devToolsExtension) ? window.devToolsExtension() : (f) => f;

// Get persisted state from local storage.
const persistedState = loadState();

export const store = createStore<IAppState>(reducer, persistedState, compose(applyMiddleware(freezeState), devToolsExtension) as GenericStoreEnhancer);

// Save persisted state to local storage at most once per second.
store.subscribe(_.throttle(() => {
    saveState(store.getState());
}, 1000));



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/store/mc-store.ts